// AUTH
export const SIGN_IN = '/api/v1/auth/login';
export const SIGN_OUT = '/api/accounts/Logout';
export const SIGN_UP = '/api/v1/auth/register';
export const GET_PROFILE = '/customer-profile';
export const GET_USER_PROFILE = '/user-profile';
export const GET_ALL_CUSTOMERS = '/customers';
export const AADHAAR_SEND_OTP = '/user/kyc/aadhar/sendotp';
export const AADHAAR_VERIFY_OTP = '/user/kyc/aadhar/verifyfotp';
export const CREATE_CUSTOMER = '/customer';
export const UPDATE_CUSTOMER = '/customer';
export const CREATE_ACCOUNT = '/account';
export const UPDATE_SHIPPING = '/account';
export const PAN_OCR = '/customer/pan/ocr';
export const PAN_NUMBER_VERIFY = '/customer/pan/verify';
export const CHECK_PAN_LIMIT = '/check-limit';
export const STATE_PIN_MAPPING = '/state-pin-mapping';
export const GSTN_LIST = '/customer/gstn/search';
export const B2B_GSTN_LIST = '/customer/b2b/gstn/search';
export const B2B_GSTN = '/customer/b2b/gstn/details';
export const B2B_SIGNUP = '/users/b2b';
export const B2B_VERIFY = '/user/b2b/verify';
export const SEND_OTP = '/user/email/code';
export const VERIFY_OTP = '/user/email/verify';
export const UPDATE_USER = '/user';
export const GET_CUSTOMER_DOCS = '/customer/docs';
export const GET_SAMPLE_DOCS = '/customer/document/type/sample';
export const DOWNLOAD_SAMPLE_DOCS = '/order/b2b/buyback/invoice/download';
export const UPLOAD_DOCS = '/customer/document';
export const UPLOAD_BANK_DOC = '/bank/verification/attachment/upload';
export const DELETE_DOC = '/document';
export const GSTN = '/customer/gstn/details';

export const GET_ALL_POSTS = '/api/v1/posts';
export const GET_ALL_POSTS_ADMIN = '/api/v1/posts/all';
export const DELETE_POST = '/api/v1/posts';
export const ADD_POST = '/api/v1/posts';
export const CHANGE_POST = '/api/v1/posts/approve';
export const GET_ALL_USERS = '/api/v1/admin/users';
export const ASSIGN_ADMIN_ROLE = '/api/v1/admin/update/userRole';
export const GET_POST_DETAILS = '/api/v1/posts';
export const EDIT_POST = '/api/v1/posts';
export const UPDATE_BANK_DETAILS = '/bank-details';
export const UPDATE_UPI_DETAILS = '/upi-details';
export const ADD_ACCOUNT = '/account';
export const ADD_GST_ACCOUNT = '/account/b2b';
export const ADD_NONGST_ACCOUNT = '/account/nongst/b2b';
export const ACCOUNT_VERIFY = '/customer/verify/bank-account';
export const UPI_VERIFY = '/customer/verify/upi';

// Wallet
export const UPI_PROVIDER = '/upi-provider';
export const RAZORPAY_UPI_ORDER = '/customer/transaction';
export const NEBK_UPI_VERIFY = '/customer/transaction';
export const RAZORPAY_NET_BANKING_ORDER = '/customer/transaction';
export const RAZORPAY_NET_BANKING_VERIFY = '/funds/add/netbank';
export const DBS_UPI = '/customer/transaction';
export const WITHDRAW = '/customer/transaction';
export const WITHDRAW_PENDING = '/customer/transaction/pending';
export const REQUEST_OTP = '/request-otp';
export const VERIFY_WITHDRAW_OTP = '/funds/withdraw/verify-otp';
export const RESEND_WITHDRAW_OTP = '/funds/withdraw/resend-otp';

// dashboard
export const QUOTE_MASTER = '/quote-master';
export const PASSBOOK_SUMMARY = '/passbook-summary';
export const PRICE_RULES = '/trade-exe-price';

//buy and sell
export const QUOTE = '/quote';
export const BUY_WITH_UPI = '/order/credit/upi';
export const VERIFY_WITH_UPI_RAZORPAY = '/order/credit/upi/razorpay';
export const BUY_WITH_NET_BANKING = '/order/credit/razorpay/order-create';
export const VERIFY_WITH_NET_BANKING_RAZORPAY = '/order/credit/netbank';
export const ORDER = '/order';
export const DOWNLOAD_PDF = '/get-invoice-vso';
export const GET_PAYMENT_STATUS = '/razorpay/payment-update';
export const ACCOUNT_STATEMENT = '/account-statement';
export const DEFAULT_ACC = '/default-bank-account';
export const ORDER_SUMMARY_PDF = '/order/pdf';
export const INVOICE_PDF = '/invoice/pdf';
export const VERIFY_OTP_BUYBACK = '/verify-otp';
export const RESEND_OTP = '/resend-otp';
export const GENERATE_TRANSACTION_OTP = '/generate-otp';
export const LOCKIN_CHECK = '/lockinPeriodCheck';
export const PAN_THRESHOLD_CHECK = '/pan/threshold';
// export const UPLOAD_BOARD_RESOLUTION = '/user/b2b/boardresolution/upload';
export const UPLOAD_BOARD_RESOLUTION = '/user/company/esign';

// passbook
export const WALLET_TRANSACTION = '/customer/transaction/log';
export const BAR_ALLOCATION_REPORT = '/bar-details/invoice-number';
export const GET_INVOICES = '/bar-details/getInvoice-number';
export const ORDER_PAY_METHOD_SUMMARY = '/order/order-payment-summary';

//nominee
export const ADD_CUSTOMER_NOMINEE = '/account/nominee/addNominee';
export const GET_CUSTOMER_NOMINEE = '/account/nominee/customerNomineeList';
export const UPDATE_CUSTOMER_NOMINEE = '/account/nominee/updateCustomerNominee';

//Push notification
export const STORE_FCM_TOKEN = '/store-token';

//SIP
export const GET_SIP_LIST = '/sip/list';
export const GET_EMANDATE_LIST = '/allemandates';
export const WITH_EM = '/create/emandate';
export const WITHOUT_EM = '/create/sip';
export const GET_SCHEDULE_LIST = '/sip/payment-schedule';
export const GET_UPCOMING_LIST = '/sip/upcoming-payment-schedule';
export const CHANGE_SIP_STATUS = '/sip/change-status';
export const CANCEL_EMANDATE = '/sip/cancel-emandate';
export const PAY_NOW_BUTTON = '/sip/is-payment-today';
export const GET_METAL_RATES = '/price/getallmetaltickerfeed';
export const SIP_DAILY_LIMIT = '/sip/limit/check';
export const DAILY_SIP_WITH_EM = '/cashfree/mandate';
export const DAILY_SIP_GET_STATUS = '/cashfree/fetch-subscription';
export const AUTO_RENEW_SIP = '/sip/auto/renew/change-status'

// SIP PROMO CODE
export const GET_COUPONS_LIST = '/all/sip/coupon';
export const VALIDATE_COUPON = '/check/sip/coupon';

//GIFT
export const CREATE_GIFT = '/create/gift';
export const SENT_GIFT_LIST = '/allgifts';
export const RECEIVED_GIFT_LIST = '/send/allgifts';
export const ACCEPT_GIFT = '/accept-gift';
export const REJECT_GIFT = '/order/rollback';

//CORPORATE GIFT
export const IS_CORP_VOUCHER_VALID = '/voucher-code/check';
export const CORP_ACCEPT_GIFT = '/corporate/accept-gift';

//Realised data
export const REALISED_DATA = '/order/realised/gain/loss';

export const SUMMARY_REPORT = '/account-statement-mail';

export const CAPITAL_GAIN = '/order/capital-gain/report';

export const IS_VALID_REFCODE = '/check/valid/referralCode';

//new code
// get coupon api
export const GET_COUPON_LIST = '/discount/valid-customer-coupons';

// validate coupon name

export const IS_COUPON_CODE_VALID = '/discount/valid-customer-secret-coupons';

// referral code
export const REFERRAL_CODE_UNDERTAKING = '/investor/undertaking';
export const IS_REFERRAL_CODE_VALID = '/investor/undertaking/status';

// new signin flow
export const SEND_NEW_OTP = '/login/send/otp';
export const VERIFY_NEW_OTP = '/login/verify/otp';
export const UPDATE_USER_DETAILS = '/update/user-details';


// kyc for fraud
export const IS_KYC_FRAUD_COMPLETE = '/kyc/complete';


// Stock Out Message
export const STOCK_OUT_MSG = '/marquee/list';

export const CUSTOMER_CONSENT = '/customer/terms-and-condition/update';

export const cognito = {
  UserPoolId: process.env.REACT_APP_CLIENT_ID || '2m346v8baplru7q1ib652uaqjo',
  ClientId: process.env.REACT_APP_API_KEY || 'ap-south-1_Uf52TrCGt',
};

export const ent_cognito = {
  userPoolId: process.env.REACT_APP_B2B_POOL_ID || 'ap-south-1_hbwaoDRYy',
  clientSecret:
    process.env.REACT_APP_B2B_CLIENT_SECRET || '23gv3hh0tojqnqmrato5rhlv6j',
};
